import { useTimeAgo } from "@/hooks";
import { cn } from "@/lib/utils";
import type { DeploymentStepStatus } from "../../../../../../schemas/codegen";
import { formatStepDuration } from "./DeploymentStep";

interface StepDurationProps {
  status: DeploymentStepStatus;
  startedAt?: Date;
  finishedAt?: Date;
}

// Component to display step duration/status
export const StepDuration = ({
  status,
  startedAt,
  finishedAt,
}: StepDurationProps) => {
  // For currently executing steps, show relative time since started
  const timeAgo = useTimeAgo(
    status === "executing" && startedAt ? startedAt.toISOString() : undefined,
    { strict: true },
  );

  if (status === "executing" && startedAt && timeAgo) {
    return <span className="font-mono">started {timeAgo}</span>;
  }

  if (status === "cancelled") {
    return <span className="font-mono">Cancelled</span>;
  }
  if (status === "skipped") {
    return <span className="font-mono">Skipped</span>;
  }

  // For successfully completed steps, show total duration
  if (
    (status === "complete" || status === "error") &&
    startedAt &&
    finishedAt
  ) {
    const duration = finishedAt.getTime() - startedAt.getTime();
    return (
      <span
        className={cn("font-mono", {
          "text-destructive": status === "error",
        })}
      >
        {formatStepDuration(duration)}
      </span>
    );
  }

  // For pending steps or steps without timing info, show nothing
  return null;
};
